<app-generic-form [title]="title" [wide]="true" [showBorder]="false">
  <form [formGroup]="sessionForm" (ngSubmit)="onSubmit()" id="sessionForm" class="d-flex flex-column gap-3"
        form-content>
    <div>
      <label class="form-label" for="startTimeLocal">Inizio sessione</label>
      <input id="startTimeLocal" type="datetime-local" class="form-control" formControlName="startTimeLocal" [attr.min]="minDateTime" [attr.max]="maxDateTime">
      @if (sessionForm.get('startTimeLocal')?.touched && sessionForm.get('startTimeLocal')?.invalid) {
        @if (sessionForm.get('startTimeLocal')?.hasError('required')) {
          <small class="text-danger">Seleziona data e ora di inizio.</small>
        }
        @if (sessionForm.get('startTimeLocal')?.hasError('pastDate')) {
          <small class="text-danger">La data di inizio non può essere nel passato.</small>
        }
      }
      @if (sessionForm.hasError('outsideEventDates') && sessionForm.get('startTimeLocal')?.touched) {
        <small class="text-danger">La data deve essere compresa tra il {{ eventStartDate }} e il {{ (eventEndDate || eventStartDate) }}.</small>
      }
    </div>

    <div>
      <label class="form-label" for="endTimeLocal">Fine sessione (opzionale)</label>
      <input id="endTimeLocal" type="datetime-local" class="form-control" formControlName="endTimeLocal" [attr.min]="minDateTime" [attr.max]="maxDateTime">
      @if (sessionForm.hasError('endBeforeStart') && sessionForm.get('endTimeLocal')?.touched) {
        <small class="text-danger">La fine sessione non puo essere precedente all'inizio.</small>
      }
      @if (sessionForm.hasError('outsideEventDates') && sessionForm.get('endTimeLocal')?.touched) {
        <small class="text-danger">La data deve essere compresa tra il {{ eventStartDate }} e il {{ (eventEndDate || eventStartDate) }}.</small>
      }
    </div>

    <div>
      <label class="form-label" for="maxPlayers">Max giocatori (opzionale, default dal tavolo)</label>
      <input id="maxPlayers" type="number" class="form-control" formControlName="maxPlayers" min="1">
    </div>

    @if (showOverride) {
      <div class="form-check">
        <input id="override" type="checkbox" class="form-check-input" formControlName="override">
        <label class="form-check-label" for="override">
          Confermo override autorizzazione sul tavolo
        </label>
      </div>
      @if (requireOverride && sessionForm.get('override')?.touched && sessionForm.get('override')?.invalid) {
        <small class="text-danger">Per questo tavolo devi confermare l'override.</small>
      }
    }
  </form>

  <div class="d-flex gap-2" form-actions>
    <button type="submit" form="sessionForm" class="btn btn-primary">
      <i class="bi bi-check-lg me-1" aria-hidden="true"></i>{{ submitLabel }}
    </button>
    <button type="button" class="btn btn-secondary" (click)="onCancel()">
      <i class="bi bi-x-lg me-1" aria-hidden="true"></i>Annulla
    </button>
  </div>
</app-generic-form>
